import { goToPreviousPayload } from "~/events";
import { trackersFactory } from "~/events/trackersFactory";

const trackerStem = "partner-onboarding-activate-page";
const trackers = trackersFactory(trackerStem);

const goToPreviousPage = (): void => trackers(goToPreviousPayload);

const partnerCodeRedeemed = (partnerSlug: string): void => {
  trackers({ action: "partner-code-redeemed", label: partnerSlug });
};

const submitActivationCode = (): void => {
  trackers({ action: "submit-activation-code-cta" });
};

export const trackActivate = {
  goToPreviousPage,
  partnerCodeRedeemed,
  submitActivationCode,
};
